// TODO move this request to different folder once is reqused also for community invite
import type { InvitationTokenKind } from 'models';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { InviteTokenDataObject } from 'models/service';

type InviteTokenRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  kind: InvitationTokenKind;
  subject_id: string;
  subject_type: 'Event';
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const getInviteToken = async (data: InviteTokenRequest) =>
  apiClient.post<InviteTokenDataObject, ApiClientResponse<InviteTokenDataObject>>(routes.tokens.generateInvitation, {
    invitation_token: data,
  });
